<template>
  <CommonChip
    :color="setClass === 'static' ? 'rust' : 'green'"
    class="text-white"
  >
    {{ setClass === 'static' ? 'Static Set' : 'Filter Set' }}
  </CommonChip>
</template>

<script lang="ts">
import { PropType, defineComponent } from 'vue';

import { Nullable } from '@/utils/types';

import CommonChip from '@/bundles/Common/components/chips/CommonChip.vue';

export default defineComponent({
  name: 'SavedSetTypeChip',

  components: { CommonChip },

  props: {
    setClass: {
      type: String as PropType<Nullable<string>>,
      default: null,
    },
  },
});
</script>
